import { render } from "./AddProduitModal.vue?vue&type=template&id=18dabd78&ts=true"
import script from "./AddProduitModal.vue?vue&type=script&lang=ts"
export * from "./AddProduitModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__